export const API_URL ='https://backend-abenviro.erdostechnologies.net/api/v1';
export const SENTRY_DNS = 'https://e05d269e7e504ea9a86eabcfcf63ffa3@sentry.io/1333434'



// WEBPACK FOOTER //
// ./src/production-env.js